// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"142":"2322ef73","899":"679253da"}[chunkId] + ".chunk.css";
};